export const localStorageKeys = {
  ACCESS_TOKEN: "ua_at",
  REFRESH_TOKEN: "ua_rt",
  REMEMBER_ME: "ua_rm",
  EMAIL: "ua_e",
  PASSWORD: "ua_p",
  MASKED_EMAIL: "ua_me",
  MASKED_PHONE: "ua_mp",
  OTP_TOKEN: "ua_o_t",
  IS_EMAIL: "ua_i_e",
  IS_MOBILE: "ua_i_m",
  THEME: "ua_th",
  EXPIRATIONTIME: "ua_ot",
  VERIFY_LOGIN_TOKEN: "ua_vt",
  USER_ROLE: "ua_rl",
  OUTFIT_ARR: "ot_arr",
  MUSIC_IDS: "muc_ds",
  WEEK_DAYS_DATA: "wk_dy",
  EDITED_WEEK_DATA: "et_wd",
  WEEK_API_DATA: "w_a_d",
};
